import ROLES from "../../contract/roles";
import { format } from "date-fns";
import { isCoOwner } from "../contract-details/SigningLinks";
import { getSigningPartyRole } from "../../contract/singing/SignatureStatus";

export function display(value) {
  if (!value) return "-";
  if (value.stringValue !== null) return value.stringValue;
  if (value.dateTimeValue !== null) return value.dateTimeValue.toString();
  if (value.intValue !== null) return value.intValue.toString();
  if (value.decimalValue !== null) return value.decimalValue.toString();
  if (value.boolValue !== null) return value.boolValue.toString();
  return "-";
}

export function adminSigningPartyName(signingParty) {
  const role = roleName(getSigningPartyRole(signingParty));
  if (isCoOwner(signingParty)) return `${role} Co-Owner`;
  return role;
}

export function roleName(role) {
  switch (role) {
    case ROLES.SELLER:
      return "Seller";
    case ROLES.BUYER:
      return "Buyer";
    default:
      throw new Error(`Unrecognized role ${role}`);
  }
}

export function dateInputValue(date) {
  return format(date, "yyyy-MM-dd");
}

export function signatureStatus(signature, invitation) {
  const signatureStatus = signature
    ? signature.signatureStatus === 1
      ? "Signed"
      : signature.signatureStatus === 2
      ? "Declined"
      : signature.sellerSignatureStatus === 1
      ? "Seller signed"
      : signature.buyerSignatureStatus === 1
      ? "Buyer signed"
      : "Signing started"
    : null;

  const invitationStatus = invitation
    ? invitation.accepted
      ? "Invitation accepted"
      : "Invitation sent"
    : null;

  return signatureStatus || invitationStatus || "";
}
